import React from 'react'
import MainLayout from '@layouts/main-layout'
import Partners from '@components/footer/partners'

const PartnersPage = () => {
  return (
    <>
      <Partners />
    </>
  )
}

PartnersPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default PartnersPage
